import React from 'react';
import { Helmet } from 'react-helmet-async';

/** Organization schema — injecte les données structurées schema.org */
export const OrganizationSchema: React.FC = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Blue Owl SAS',
    url: 'https://blueowl.fr',
    logo: 'https://blueowl.fr/logo.svg',
    description:
      "Experts en IoT industriel, intégration d'APIs, applications mobiles et web. Basés en France.",
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'France',
      addressCountry: 'FR',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      url: 'https://blueowl.fr/#contact',
      availableLanguage: ['French', 'English'],
    },
    sameAs: ['https://www.linkedin.com/company/colibri-technologies'],
    areaServed: ['FR', 'EU'],
    serviceType: ['IoT', 'Software Development', 'API Integration', 'Mobile Development'],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

interface BreadcrumbItem {
  name: string;
  url: string;
}

/** BreadcrumbList schema pour les pages internes */
export const BreadcrumbSchema: React.FC<{ items: BreadcrumbItem[] }> = ({ items }) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};
